
<template>
  <div class="shelves-log">
    <Search ref="searchRef" @search="search" :searchType="searchType" :staffList="staffList" @changeSearchType="changeSearchType" />
    <Table :list="logList" @search="search" :searchType="searchType" />
     <el-pagination
      :style="{ padding: '8px 16px', textAlign: 'right' }"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.pageNo"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pagination.pageSize"
      :layout="layout"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import Search from './search.vue';
import Table from './table.vue';
import { getStaffList } from '@servers/base/user/index.js';
import { queryLogsListApi } from "@/servers/prod/center/shopGoods.js"
import { mapGetters } from "vuex";

export default {
  components: {
    Search,
    Table,
  },
  data() {
    return {
      logList: [],
      pagination: {
        pageNo: 1,
        pageSize: 10,
        total: -1
      },
      searchType:0,
      staffList:[]
    }
  },
  computed: {
    ...mapGetters(["routerPrefix"]),
    pageId() {
      return this.routerPrefix+"log"
    },
    total(){
      let { total,pageSize,pageNo } = this.pagination
      let newTotal = total
      if(total === -1){
        newTotal = (pageSize * pageNo) + pageSize
      }
      return newTotal
    },
    layout(){
      let { total } = this.pagination
      if(total != -1){
        return 'total, sizes, prev, pager, next, jumper'
      }else{
        return 'sizes,prev,pager,next'
      }
    }
  },
  watch:{
    searchType:{
      handler(val) {
        this.search({queryType:val});
      },
    }
  },
  methods: {
    search(p = {}) {
      let params = this.$refs.searchRef.getParams();
      const { pageNo,pageSize } = this.pagination
      let data = {
        ...params,
        pageNo,
        pageSize,
        ...p,
      }
      queryLogsListApi(data).then(res => {
        if(res){
          const { list,page } = res
          this.logList = list || [];
          this.pagination = {
            pageNo: page.pageNo || 1,
            pageSize: page.pageSize || 10,
            total: page.total || -1
          }
        }else{
          this.logList = []
        }
      })
    },
    // 分页改变
    handleSizeChange(val) {
      this.$set(this.pagination, 'pageNo', 1)
      this.$set(this.pagination, 'pageSize', val)
      this.search();
    },
    handleCurrentChange(val) {
      this.$set(this.pagination, 'pageNo', val)
      this.search();
    },
    changeSearchType(val){
      this.searchType = val
    },
    getStaffData(){
      let params = {
        pageNo:1,
        pageSize:999999
      }
      getStaffList(params).then(res => {
        if(res){
          this.staffList = res.list
        }
      })
    },
  },
  mounted() {
    this.search()
    this.getStaffData();
  }

}
</script>

<style lang="scss" scoped>

</style>
